import React from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/v.jpg";
import ContactImg2 from "../../assets/img/j.jpg";
import ContactImg3 from "../../assets/img/museum.png";

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <HeaderInfo>
            <h1 className="font40 extraBold">Let's Get in Touch</h1>
            <p className="font13">
              Reach out to us to learn more about how Kupeel can enhance your museum's audio experiences.
              <br />
              We're here to help you transform your ideas into immersive audio content.
            </p>
          </HeaderInfo>
              <AppointmentButton
                href="https://calendly.com/julien-bardin/30min"
                target="_blank"
                className="pointer animate radius8"
              >
                Schedule an Appointment
              </AppointmentButton>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div style={{ width: "50%" }} className="flexNullCenter flexColumn">
                <ContactImgBox>
                  <img src={ContactImg1} alt="museum" className="radius6" />
                </ContactImgBox>
                <ContactImgBox>
                  <img src={ContactImg2} alt="museum" className="radius6" />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img src={ContactImg3} alt="museum" className="radius6" style={{width:"100%"}}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #89023E;
  background-color: #89023E;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #FF7817;
    border: 1px solid #89023E;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const AppointmentButton = styled.a`
  display: inline-block;
  border: 1px solid #89023E;
  background-color: #89023E;
  width: 100%;
  padding: 15px;
  text-align: center;
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
  :hover {
    background-color: #FF7817;
    border: 1px solid #89023E;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 20px auto 0;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px; 
  align-self: flex-end; 
  margin: 10px 30px 10px 0;
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;
